<template>
  <div class="index_footer">
    <div class="footer_box content">
      <div class="footer_top">
        <div class="fotter_l">
          <img src="../../assets/images/bottom_left_icon.png" alt>
        </div>
        <div class="footer_t">
          <span></span>
          <span v-for="(item,index) in bottomNav1" :key="index" @click="goRouter(item.path)">{{
              item.name
            }}</span>
        </div>
        <div class="fotter_r">
          <dl>
            <dt>
              <img style="height: 70px;width: 70px;margin: 2px"
                   src="../../assets/images/wxchat_icon.png" alt>
            </dt>
          </dl>
          <dl>
            <dt>
              <img style="height: 70px;width: 70px;margin: 2px"
                   src="../../assets/images/weibo_icon.png" alt>
            </dt>
          </dl>
        </div>
      </div>
    </div>
    <div class="footer_box2 content">
      <div class="footer_bottom">
        <div class="footer_bottom_1">
          <p>招生咨询热线：0316-2901888、0316-2901877</p>
        </div>
        <div class="footer_bottom_2">
          <p>学校地址：</p>
          <div class="footer_bottom_2_con">
            <p>河北省廊坊市经济开发区东方大学城</p>
          </div>
        </div>
        <div class="footer_bottom_3">
          <p>邮箱：oitoffice@126.com</p>
        </div>
        <div class="footer_bottom_4">
          <img src="../../assets/images/bottom_right_icon.png" alt="网络备案">
          <div class="footer_bottom_4_con">
            <p>冀ICP备17030115号-1</p>
            <p>冀ICP备17030115号-2</p>
          </div>
        </div>
        <div class="footer_bottom_5">
          <div class="footer_bottom_5_con">
            <img src="../../assets/images/gonganwangbei.png" style="float:left;"
                 alt>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:white;">冀公网安备
              13109902000016号</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import home from '../../api/home.js'

export default {
  name: 'mainfooter',
  components: {},
  data () {
    return {
      bottomNav1: [
        {name: '学校简介', path: '/profile/10'},
        {name: '合作交流', path: '/common/more/28'},
        {name: '招生工作', path: '/enrollment/office/17'},
        {name: '联系方式', path: '/joinus/12'},
        {name: '版权申请通道', path: '/copyright'},
        {name: '图书馆', path: 'https://hbdfxytsg.mh.chaoxing.com/'},
      ],
      bottomNav2: []
    }
  },
  created () {

  },
  methods: {
    // 跳转
    goRouter (path) {
      if (path.startsWith('https://')) {
        window.open(path, '_blank')
        return
      }
      this.$router.push({path})
    }
  }
}
</script>

<style lang="less" scoped>
.index_footer {
  min-width: 1200px;
  height: 170px;
  background: #9e070e;
  width: 100%;

  .footer_box {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    .footer_top {
      width: 1200px;
      height: 120px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .fotter_l {
        width: 335px;

        img {
          cursor: pointer;
          width: 100%;
          height: 100%;
        }
      }

      .footer_t {
        width: 45%;
        display: flex;
        justify-content: space-between;

        span {
          line-height: 24px;
          margin-right: -1px;
          color: #fff;
          font-size: 17px;
          cursor: pointer;
        }
      }

      .fotter_r {
        width: 20%;
        height: 150px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        line-height: 24px;
        color: #fff;
        font-size: 12px;

        dl {
          position: relative;

          dt {
            margin: 0;
            padding: 0;

            img {
              cursor: pointer;
              height: 70px;
              width: 70px;
              margin: 2px;
            }
          }
        }
      }
    }
  }

  .footer_box2 {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #8c0000;

    .footer_bottom {
      width: 1200px;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 10px;
      color: white;

      .footer_bottom_1 {
        width: 22%;
        font-size: 10px;

        p {
          margin: 0;
          padding: 0;
          font-size: 10px;
        }
      }

      .footer_bottom_2 {
        font-size: 10px;
        display: flex;
        align-items: center;

        p {
          margin: 0;
          padding: 0;
        }

        .footer_bottom_2_con {
          font-size: 10px;
          color: white;

          p {
            font-size: 10px;
            color: white;
          }
        }
      }

      .footer_bottom_3 {
        display: flex;
        align-items: center;
        font-size: 10px;
        color: white;
      }

      .footer_bottom_4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10px;
        color: white;
        cursor: pointer;

        img {
          cursor: pointer;
          margin: 0 10px;
          width: 18px;
          height: 18px;
        }

        .footer_bottom_4_con {
          color: #fff;

          p {
            font-size: 10px;
            margin: 0;
            padding: 0;
          }
        }
      }

      .footer_bottom_5 {
        cursor: pointer;

        .footer_bottom_5_con {
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;

          p {
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            font-size: 10px;
          }
        }
      }
    }
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/Footer.vue